//  theme
export const SUCCESS_THEME = "SUCCESS_THEME";
export const LOADING_THEME = "LOADING_THEME";
// cover
export const SUCCESS_COVER = "SUCCESS_COVER";
export const LOADING_COVER = "LOADING_COVER";
